const DOMAIN_NAME = 'menu';
const MENU_ROUTE_ID = 31;
const ROWS_PER_PAGE = 10;
const FORM_NAME = 'menuForm';
const DELETE_CONFIRMATION_DIALOG = 'deleteMenuConfirmation';

// API endpoints
const API_ENDPOINTS = {
    GET_ALL: '/menu/get/all',
    GET_BY_ID: '/menu/get',
    CREATE: '/menu/create',
    UPDATE: '/menu/update',
    DELETE: '/menu/delete',
    GET_PERMISSIONS: '/permission/get/all'
};

// Table columns configuration
const TABLE_COLUMNS = [
    { id: 'menuId', label: 'Menu ID', minWidth: 100, sortable: true },
    { id: 'name', label: 'Name', minWidth: 170, sortable: true },
    { id: 'code', label: 'Code', minWidth: 130, sortable: true },
    { id: 'parentId', label: 'Parent ID', minWidth: 100, sortable: true },
    { id: 'groupId', label: 'Group ID', minWidth: 100, sortable: true },
    { id: 'serial', label: 'Serial', minWidth: 80, sortable: true },
    { id: 'permissions', label: 'Permissions', minWidth: 200, sortable: false },
    { id: 'actions', label: 'Actions', minWidth: 150, sortable: false, align: 'center' }
];

// Sort options
const SORT_OPTIONS = [
    { value: 'menuId', label: 'Menu ID' },
    { value: 'name', label: 'Name' },
    { value: 'code', label: 'Code' },
    { value: 'serial', label: 'Serial' },
    { value: 'parentId', label: 'Parent ID' },
    { value: 'groupId', label: 'Group ID' }
];

export {
    DOMAIN_NAME,
    MENU_ROUTE_ID,
    ROWS_PER_PAGE,
    FORM_NAME,
    DELETE_CONFIRMATION_DIALOG,
    API_ENDPOINTS,
    TABLE_COLUMNS,
    SORT_OPTIONS
};
